module.exports = __webpack_public_path__ + "img/1009c_1.cad0c289.jpg";